<template>
  <div class="wrap">
    <div class="other_section">
      <div class="title">拍卖</div>
      <div class="itembox">
        <div @click="jump" v-for="item in aucList" :key="item" class="item">
          <img :src="item.icon" alt="" />
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="other_section">
      <div class="title">设置</div>
      <div class="itembox">
        <div @click="jump" v-for="item in szList" :key="item" class="item">
          <img :src="item.icon" alt="" />
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="other_section">
      <div class="title">其他</div>
      <div class="itembox">
        <div @click="jumpInvitation" v-for="item in other" :key="item" class="item">
          <img :src="item.icon" alt="" />
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'other',
  components: {},
  data() {
    return {
      aucList: [
        {
          name: '创建拍卖专场',
          icon: 'https://img.zai-art.com/zaiart/saas/image/md/50dc8fa5af4478f7eb6844bdd67db28c.png',
        },
        {
          name: '拍卖设置',
          icon: 'https://img.zai-art.com/zaiart/saas/image/md/d3bfd0a452a6992cd0522c6eed97c30b.png',
        },
      ],
      szList: [
        {
          name: '员工管理',
          icon: 'https://img.zai-art.com/zaiart/saas/image/md/a4b61aef841cd827cc572320ff8415b6.png',
        },
        {
          name: '权限管理',
          icon: 'https://img.zai-art.com/zaiart/saas/image/md/92ed887a862e38dc8b320ccd07a4f939.png',
        },
        {
          name: '店铺信息',
          icon: 'https://img.zai-art.com/zaiart/saas/image/md/45dcc43d4cf7c9c35397fd623446e6ab.png',
        },
      ],
      other: [
        {
          name: '邀请有礼',
          icon: 'https://img.zai-art.com/zaiart/saas/image/md/9ccb9c542e82656e8ea348d440bb0f6a.png',
        },
      ],
    };
  },
  computed: {},
  methods: {
    jump() {
      this.$router.push({ path: '/404' });
    },
    jumpInvitation() {
      let path = encodeURIComponent(`/pages/my/invitation/index`);
      let title = encodeURIComponent(`进入邀请有礼`);
      wx.miniProgram.navigateTo({
        url: `/pages/openMini/index?path=${path}&appid=wx85f3340de9840fb8&title=${title}`,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.wrap {
  background: #f8f8f8;
  padding-top: 12px;
  .other_section {
    width: 93.6%;
    margin: 0 auto;
    padding-top: 20px;
    background: #fff;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
    border-radius: 4px;
    padding-bottom: 25px;
    margin-bottom: 12px;
    .title {
      padding-left: 20px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 25px;
      margin-bottom: 20px;
    }
    .itembox {
      display: flex;
      justify-content: flex-start;
      padding: 0 12px;
      .item {
        width: 33%;
        display: inline-block;
        text-align: center;
        img {
          width: 60px;
          height: 60px;
          margin-bottom: 15px;
        }
        .name {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #222222;
          line-height: 14px;
        }
      }
    }
  }
}
</style>
